const VALUE_PROP_NAMES = {
  CONTROL: 'control',
  ONE_NUMBER: 'oneNumber',
  FINANCIAL_ADVICE: 'financialAdvice',
  CASHFLOW_GOAL: 'cashflowGoal',
};

const VALUE_PROPS = [
  {
    name: VALUE_PROP_NAMES.CASHFLOW_GOAL,
    imageName: 'no-overdraft.png',
    title: 'עם התזרים של riseup אפשר',
    subtitle: 'התנהלות עם תזרים riseup מאפשרת לראות צמיחה חיובית וחיסכון תוך 3 חודשים או פחות!',
  },
  {
    name: VALUE_PROP_NAMES.CONTROL,
    imageName: 'group-7@3x.png',
    title: 'אפשר לעשות סדר במצב הכלכלי ולהנות משקט נפשי',
    subtitle: 'riseup מרכז את כל ההכנסות וההוצאות שלך במקום אחד. ונותן לך תמונת מצב כלכלית מדויקת באופן אוטומטי ופשוט.',
  },
  {
    name: VALUE_PROP_NAMES.ONE_NUMBER,
    imageName: 'how-much.png',
    title: 'אפשר לדעת מתי לעצור עם ההוצאות ומתי להמשיך כרגיל',
    subtitle: 'התזרים של riseup יודע כמה כסף נכנס וכמה כסף יוצא ומציג לך מספר אחד המתעדכן כל יום ונותן לך שליטה.',
  },
  {
    name: VALUE_PROP_NAMES.FINANCIAL_ADVICE,
    imageName: 'group-cx@3x.png',
    title: 'אפשר להתייעץ ברגעים החשובים',
    subtitle: 'הצוות שלנו מלווה אותך בתהליך הצמיחה הכלכלית שלך וזמין בשבילך בכל התלבטות כלכלית, קטנה או גדולה.',
  },
];

export default {
  VALUE_PROPS,
  VALUE_PROP_NAMES,
};



// WEBPACK FOOTER //
// ./src/pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/consts/value-props.js